import { MDText } from 'i18n-react';

import { ClockIcon, WarningIcon } from '@motorway/mw-highway-code';
import { BADGE_VARIANT } from '@motorway/mw-highway-code/enums';

import Texts from './vehicleCardReturningUser.text.json';

const LocalT = new MDText(Texts);

export const getExpiredBadgeData = (days: number):{
  icon: JSX.Element;
  text: string;
  variant: (typeof BADGE_VARIANT)[keyof typeof BADGE_VARIANT];
} => {
  if (days < 1) {
    return {
      icon: <WarningIcon data-testid="WarningIcon" />,
      text: LocalT.translate('expiringLabel.expired') as string,
      variant: BADGE_VARIANT.WARNING,
    };
  }

  if (days === 1) {
    return {
      icon: <ClockIcon data-testid="ClockIcon" />,
      text: LocalT.translate('expiringLabel.expiringSoon') as string,
      variant: BADGE_VARIANT.WARNING,
    };
  }

  return {
    icon: <ClockIcon data-testid="ClockIcon" />,
    text: LocalT.translate('expiringLabel.expiring', { days }) as string,
    variant: days >= 3 ? BADGE_VARIANT.PRIMARY : BADGE_VARIANT.WARNING,
  };
};
